import type { Meta, StoryObj } from '@storybook/web-components';

import { createDocumentation } from '@/globals/documentation/story';
import docs from './pn-page-nav-docs.json';

const { argTypes, textContent } = createDocumentation(docs);

/** Page nav */
const meta: Meta<HTMLPnPageNavElement> = {
  title: 'Components/Navigation/Page Nav/Menu',
  parameters: {
    docs: {
      description: {
        story: textContent,
      },
    },
    actions: {
      handles: ['navchange', 'itemselection'],
    },
  },
  args: {
    value: 'one',
    dropdown: '',
    navid: '',
  },
  argTypes,
};

type Story = StoryObj<HTMLPnPageNavElement>;

export default meta;

import { createPnPageMenu } from '../renderMenu';

export const PnPageNav: Story = {
  name: 'pn-page-nav',
  render: args => createPnPageMenu(args, { isMenu: true }),
};

/** With dropdown. */
export const PnPageNavDropDown = {
  name: 'pn-page-nav (dropdown)',
  render: PnPageNav.render,
  args: {
    dropdown: 'More',
  },
};
